export const usersQuicksearch = {
  results: [
    {
      domain: 'users',
      domainType: 'user',
      id: 2,
      full_name: 'Alice Mills',
      email: 'testuser2@example.com',
      qri: 'https://qri.staging.qualio.com/dXNlcnMvdXNlci8tLzI',
    },
    {
      domain: 'users',
      domainType: 'user',
      id: 7769,
      full_name: 'John Doe',
      email: 'lol@lol.com',
      qri: 'https://qri.staging.qualio.com/dXNlcnMvdXNlci8tLzc3Njk',
    },
    {
      domain: 'users',
      domainType: 'user',
      id: 537,
      full_name: 'Quality Staff Two',
      email: 'qualitystaff@lovelacetwo.com',
      qri: 'https://qri.staging.qualio.com/dXNlcnMvdXNlci8tLzUzNw',
    },
  ],
  totalRelation: 'eq',
  total: 3,
  page: 1,
  size: 10,
};
